import { AlertFactory } from 'alerts/Alert'
import ModalViewModel from 'infra/ModalViewModel'
import { action, makeObservable, observable, override } from 'mobx'
import { task } from 'mobx-task'
import { lengthBetween } from 'utils/validation-utils'
import { validationContext } from 'validx'
import NotesViewModel from '../NotesViewModel'

export default class NotesDialogViewModel extends ModalViewModel {
  @observable text = ''

  readonly fieldLengths = {
    text: { min: 1, max: 5000 },
  } as const

  validation = validationContext(this, {
    text: [
      lengthBetween(
        this.fieldLengths.text.min,
        this.fieldLengths.text.max,
        `Notes must be between ${this.fieldLengths.text.min} and ${this.fieldLengths.text.max} characters`,
      ),
    ],
  })

  constructor(
    private notesVM: NotesViewModel,
    private newAlert: AlertFactory,
  ) {
    super()
    makeObservable(this)
  }

  @action.bound
  validate() {
    return this.validation.reset().validate().isValid
  }

  @action
  reset() {
    this.text = ''
  }

  @override
  show() {
    this.text = this.notesVM.notesSupportingItemInput.text || ''
    super.show()
  }

  submit = task.resolved(async () => {
    if (!this.notesVM.canEditNotes || !this.validate()) {
      return
    }

    try {
      await this.notesVM.infoGatheringStore.provideSupportingItemNotes({
        jobId: this.notesVM.job.id,
        itemId: this.notesVM.notesSupportingItem!.id,
        notes: this.text,
      })
      this.reset()

      this.close()
    } catch (error) {
      this.newAlert().fromError(error).show()
      console.error(error)
    }
  })
}
